// extracted by mini-css-extract-plugin
module.exports = {"notifySwitch":"notifySwitch_notifySwitch__1ZZCY","switch":"notifySwitch_switch__3VWvT"};